import React, { useState, useEffect, useCallback } from 'react'
import styled from '@emotion/styled'
import { Link } from 'gatsby'
import MaxWidthWrapper from 'src/components/atoms/wrappers/MaxWidthWrapper'
import { Logo } from 'src/components/atoms/imageComponents/Logo'
import { Styles } from 'src/components/shared/CssValues'
import { Typography } from 'src/components/atoms/Typography'

const PC_HEADER_HEIGHT = '80px'
const SP_HEADER_HEIGHT = '65px'
const HEADER_BREAK_POINT = '1100px'

const PartnerHeader = () => {
    return (
        <Container>
            <HeaderItems>
                <HeaderItemsInner>
                    <LogoWrapper to="/">
                    <HeaderLogo/>
                    </LogoWrapper>
                    <ColorButtonWrapper>
                    <ColorButton to="/partner#info" style={{ textDecoration: 'none' }}>
                        <ColorButtonText>
                        お問い合わせ
                        </ColorButtonText>
                    </ColorButton>
                    </ColorButtonWrapper>
                </HeaderItemsInner>
            </HeaderItems>
        </Container>
    )
    }

    const Container = styled.div`
    width: 100%;
    z-index: 5000;
    transition: background-color 0.3s, box-shadow 0.3s;
    `

    const HeaderMaxWidthWrapper = styled(MaxWidthWrapper)`
    padding: 0 ${Styles.spacing[8]};
    box-sizing: border-box;
    `

    const LogoWrapper = styled(Link)`
    display: flex;
    margin: 0 auto 0 10px;
    @media screen and (min-width: ${HEADER_BREAK_POINT}) {
        margin: 0 40px 0 30px;
    }
    `

    const HeaderLogo = styled(Logo)`
    max-width: 150px;
    height: auto;
    @media screen and (min-width: ${HEADER_BREAK_POINT}) {
        max-width: 190px;
    }
    `

    const HeaderItems = styled.div`
    display: none;
    display: block;
    `

    const HeaderItemsInner = styled.div`
    display: flex;
    justify-content: space-between;
    `

    const ColorButtonWrapper = styled.div`
    display: flex;
    gap: ${Styles.spacing[6]};
    height: ${PC_HEADER_HEIGHT};
    margin-left: 30px;
    `

    const ColorButton = styled(Link)`
    line-height: ${PC_HEADER_HEIGHT};
    margin: 0 ${Styles.spacing[7]} 0 0;
    `

    const ColorButtonText = styled(Typography)`
    display: inline-block;
    background-color: #ef5e4b;
    font-size: 13px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: 1.12px;
    text-align: center;
    color: #fff;
    border-radius: ${Styles.borderRadius[1]};
    padding: 0 10px;
    height: 30px;
    line-height: 30px;
    transform: translateY(-1px);
`



export default PartnerHeader
